<script setup>
import { inject, ref, onMounted } from 'vue';
import { requestPaymentURL, getFormValuesFromLocalStorage } from '@/utils';
import Loader from '@components/loader.vue';

const apiPayment = ref('');
const isLoading = ref(true);
const { failPayment } = inject('step');
const savedFields = getFormValuesFromLocalStorage();

if(savedFields?.paymentGateway){
  window.location = '/steps/?page_status=ok_page';
}

const fetchPaymentURL = async () => {
  try {
    const response = await requestPaymentURL();
    apiPayment.value = response;
  } catch (error) {
    console.error('Error fetching payment URL:', error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchPaymentURL();
});
</script>
<template>
  <div class="form__group">
    <div class="error_message" v-if="failPayment">
      <h3>{{ __('Something went wrong. Can you try again?') }}</h3>
    </div>
    <div class="form__body form__body--flex" v-if="!isLoading && apiPayment?.data.status">
      <iframe id="payment-iframe" :src="apiPayment.data.url" style="width:100%;" frameborder="0"></iframe>
    </div>
    <Loader v-if="isLoading" color="#2563eb" />
  </div>
</template>

<style scoped>
.form__group {
  width: 100%;
}
</style>
